import React from 'react';
import { Button, Stack } from "@curves/ui-base";

const PaymentButtons = ({ className, onCashPayment, onCardPayment, disabled = false }) => {
    return (
        <Stack className={className} direction="row">
            <Button
                variant="outlined"
                fullWidth
                className="pos-button pos-credit-button"
                onClick={onCardPayment}
                disabled={disabled}
            >
                信用卡結帳
            </Button>

            <Button
                variant="contained"
                fullWidth
                className="pos-button pos-cash-button"
                onClick={onCashPayment}
                disabled={disabled}
            >
                現金結帳
            </Button>
        </Stack>
    );
};

export default PaymentButtons;
